var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse-item',{attrs:{"name":_vm.name}},[_c('template',{slot:"title"},[_c('tasks-modal-list-item-title',{attrs:{"task":_vm.task}})],1),_c('tasks-modal-list-item-content',{attrs:{"task":_vm.task}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }